import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TimelineScorecard from '../TimelineScorecard.vue'
import { Timesheets } from '../../types/timers'
import { computed, ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { formatTravelActivitesForTable } from '../../store/timers'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../../store/useUserStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'PreviousActivitiesScorecardDistance',
  props: {
    timesheets: {}
  },
  setup(__props: any) {

const props = __props

const totalDistance = computed(() => {
  return props.timesheets.reduce((acc, timesheet) => {
    return acc + timesheet.toBePaidDistance
  }, 0)
})

const travelActivities = computed(() => {
  const data = props.timesheets.flatMap((timesheet) => timesheet.timers)
  return formatTravelActivitesForTable(data)
})

const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
const payPeriod = (key: string) => t(`payPeriod.${key}`)
const user = storeToRefs(useUserStore())
const headerText = computed(() => {
  return `${payPeriod('toBePaid')} ${timelineLabel(user.distance.value)}`
})

const value = ref(false)
//todo change distance

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecard, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = true)),
      header: headerText.value,
      subheader: totalDistance.value
    }, null, 8, ["header", "subheader"]),
    _createVNode(BaseModal, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(`${_unref(t)('form.total')} ${timelineLabel(_unref(user).distance.value)}: ${totalDistance.value}`), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(FilteringDataDisplay, {
          "table-data": travelActivities.value,
          "enable-filters": false
        }, null, 8, ["table-data"])
      ]),
      actions: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          rounded: "",
          flat: "",
          label: _unref(t)('form.close')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})